import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { selectedPatient, therapyPlanningAction } from 'src/redux/actions/constant';
import therapyPlanningService from '../../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0,
  GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0,
  GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0,
  GET_PATIENT_THERAPY_PLANNING_LOADING_2_0,
} = therapyPlanningAction;
const { SELECT_PATIENT_FOR_THERAPY } = selectedPatient;

function* getTherapyPlanningPatient_2_0(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PATIENT_THERAPY_PLANNING_LOADING_2_0 });
    const response = yield call(therapyPlanningService.getTherapyPlanningPatient, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PATIENT_THERAPY_PLANNING_SUCCESS_2_0, payload: response.data });
      if (payload?.payload?.isFirstTimeCall) {
        yield put({ type: SELECT_PATIENT_FOR_THERAPY, payload: response.data?.data?.content[0] });
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PATIENT_THERAPY_PLANNING_FAILURE_2_0, payload: error });
  }
}

function* getTherapyPlanningPatientSaga_2_0() {
  yield takeEvery(GET_PATIENT_THERAPY_PLANNING_REQUEST_2_0, getTherapyPlanningPatient_2_0);
}

export default getTherapyPlanningPatientSaga_2_0;
